import { getPresignedUploadUrl } from '@onesource/services';

export const UPLOAD_PLACEHOLDER = 'Uploading image…';

export const uploadImage = async (file: File): Promise<string> => {
  const extension = file.name.includes('.') ? file.name.split('.').pop() : '';
  const baseName = file.name.replace(/\.[^.]+$/, '');
  const key = extension ? `${Date.now()}-${baseName}.${extension}` : `${Date.now()}-${baseName}`;

  const { uploadUrl, publicUrl } = await getPresignedUploadUrl(key, file.type, file.size);

  if (!publicUrl) {
    throw new Error('No public URL returned');
  }

  const res = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });

  if (!res.ok) {
    throw new Error('Upload failed');
  }

  return publicUrl;
};
